export default __webpack_public_path__ + "static/media/Catalog_Import_Template.f12d8665.csv";